// extracted by mini-css-extract-plugin
export default {"bell-icon":"CampaignPopUp_bell-icon__U9iKB","title":"CampaignPopUp_title__57agF","alert":"CampaignPopUp_alert__Z5M1S","close-btn":"CampaignPopUp_close-btn__snNtX"};